/**
 * D-502 (CU-14zefhy1r1w): CoPilot requests no longer open the app-wide "Requested operation failed" dialog (see
 * `isAssistantApiUrl` in the error interceptor), so the chat says what went wrong itself. The API answers a friendly
 * 503 `{error}` when PythonMagic is restarting (after one retry of the submit); that text is shown as it is.
 */
import {serverReason} from 'app/layout/components/hauliermagic-assistant-chat/hauliermagic-assistant-changes';
import {ASSISTANT_LABEL} from 'app/layout/components/hauliermagic-assistant-chat/hauliermagic-assistant-label';

export const ASSISTANT_RESTARTING_TEXT = `${ASSISTANT_LABEL} is restarting. Try again in a moment.`;

/**
 * The reason to show in the chat for a failed CoPilot request: the server's own words (`{error}` / `{detail}` /
 * `{message}` or a short plain-text body, one line, at most 300 characters); for a 502/503/504 without one, a
 * "restarting" note; otherwise '' (the caller uses its own fallback text).
 */
export function assistantErrorReason(error: any): string {
    const reason = serverReason(error).replace(/\s+/g, ' ').trim().substring(0, 300);
    if (reason) {
        return reason;
    }
    const status = error?.status;
    return status === 502 || status === 503 || status === 504 ? ASSISTANT_RESTARTING_TEXT : '';
}
